import React from "react";

import { FlagIconProps } from "../../@types/Components";

const FlagIcon = (props: FlagIconProps): JSX.Element => {
    const { code } = props;

    const iconStyle = {
        display: 'flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        width: "2rem",
        height: "1.66rem",
        marginRight: ".5rem",
        boxShadow: "0 0 2px 2px rgba(0, 0, 0, 0.03)",
        alignSelf: "center"
    };

    const getIcon = () => {
        const iconName = code.toLowerCase();
        const iconPath = `/img/flags/${iconName}.svg`;
        return <img src={iconPath} alt={code} style={iconStyle} />;
    };

    return (getIcon());
}

export default FlagIcon;
